import { c as _c } from "react/compiler-runtime";
import { MenuItem, Typography, Select } from '@mui/material';
import { RelativeTimeOptions } from '@/data/inventory/relativeTime';
import { ALL_TIME, type TimeFilterValue } from './dateFilterTypes';
const ALL_TIME_LABEL = 'all time';
export const RelativeTimeSelector = t0 => {
  const $ = _c(19);
  const {
    selectedRelativeKey,
    onRelativeKeyChange,
    showAllTime: t1,
    stripInPrefix: t2
  } = t0;
  const showAllTime = t1 === undefined ? false : t1;
  const stripInPrefix = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== stripInPrefix) {
    t3 = label => stripInPrefix ? label.replace(/^in /, "") : label;
    $[0] = stripInPrefix;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const formatLabel = t3;
  let t4;
  if ($[2] !== formatLabel || $[3] !== selectedRelativeKey) {
    t4 = selectedRelativeKey === ALL_TIME ? ALL_TIME_LABEL : formatLabel(RelativeTimeOptions[selectedRelativeKey]?.label ?? selectedRelativeKey);
    $[2] = formatLabel;
    $[3] = selectedRelativeKey;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const displayLabel = t4;
  let t5;
  if ($[5] !== displayLabel) {
    t5 = () => <Typography variant="subtitle1" className="font-medium">{displayLabel}</Typography>;
    $[5] = displayLabel;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onRelativeKeyChange) {
    t6 = e => onRelativeKeyChange(e.target.value);
    $[7] = onRelativeKeyChange;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== showAllTime) {
    t7 = showAllTime && <MenuItem value={ALL_TIME} divider={true}>{ALL_TIME_LABEL}</MenuItem>;
    $[9] = showAllTime;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== formatLabel) {
    t8 = Object.entries(RelativeTimeOptions).map(t9 => {
      const [key, option] = t9;
      return <MenuItem key={key} value={key} divider={option.divider}>{formatLabel(option.label)}</MenuItem>;
    });
    $[11] = formatLabel;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== selectedRelativeKey || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <Select variant="standard" value={selectedRelativeKey} renderValue={t5} onChange={t6}>{t7}{t8}</Select>;
    $[13] = selectedRelativeKey;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};